import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import {ApplicationActions} from "../../data/Action";
import server from "../../script/store";

/**
 * Component that alerts if you click outside of it
 */
export default class DialogConfirmation extends Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Set the wrapper ref
     */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.onCancelOrderToStore();
        }
    }

    render() {

        const scheduledConfirmation = (this.props.appState.scheduled.action.confirmation ?
            this.props.appState.scheduled.action.confirmation : []);

        if (scheduledConfirmation.length === 0) {
            return null;
        }


        return (
            <div ref={this.setWrapperRef} className="page-wrap">
                <div className="container">
                    <div className="message animated bounceIn">
                        <div className="display-table">
                            <div className="display-table-cell modal-warning">
                                <div className="modal-warning-header">
                                    <h2>Entregar encomendas na loja?</h2>
                                </div>
                                <div className="modal-warning-body">
                                    {this.renderScheduledOrders(scheduledConfirmation)}
                                </div>
                                <div className="modal-warning-footer">
                                    <button id="btn_alarm_close" onClick={() => {
                                        this.onSendOrderToStore(scheduledConfirmation)
                                    }}>Aceitar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }


    onSendOrderToStore(order) {
        let orderIds = [];
        order.forEach(entry => orderIds.push(entry.id));

        console.log("Push to dispatch.... (" + orderIds + ")");
        ApplicationActions.onClickScheduledConfirmation(order);

        server.fastForwardScheduledOrder(orderIds);
    }

    onCancelOrderToStore(order) {
        ApplicationActions.onClickScheduledFastForward([]);
    }


    renderScheduledOrders(scheduledOrders) {

        const listItems = scheduledOrders.map(entry =>
            <tr>
                <td>{moment(entry.deliveryDate).format("HH:mm")}</td>
                <td> - </td>
                <td>{entry.address}</td>
            </tr>
        );

        return (
            <table>
                <tbody>
                {listItems}
                </tbody>
            </table>
        );
    }

}

/*
DialogConfirmation.propTypes = {
    children: PropTypes.element.isRequired,
}; */



// WEBPACK FOOTER //
// ./src/app/Dialog/confirmation.js